import {inject, Injectable} from '@angular/core';
import {SessionStore} from '../stores/session.store';
import {UserProfileStore} from '../stores/user-profile.store';
import {ROLE_LEVEL, UserRole} from '../models/user.models';

@Injectable({ providedIn: 'root' })
export class PermissionService {
	private session = inject(SessionStore);
	private profileStore = inject(UserProfileStore);

	// --- TENANT ROLES ---
	hasTenantRole(role: string): boolean {
		return this.session.snapshot.rolesTenant.includes(role);
	}

	hasAnyTenantRole(roles: string[]): boolean {
		if (!roles?.length) return true;

		return roles.some(r =>
			this.session.snapshot.rolesTenant.includes(r)
		);
	}

	// --- MAILBOX ROLES ---
	hasMailboxRole(role: string): boolean {
		return this.session.snapshot.rolesMailbox.includes(role);
	}

	hasAnyMailboxRole(roles: string[]): boolean {
		if (!roles?.length) return true;

		return roles.some(r =>
			this.session.snapshot.rolesMailbox.includes(r)
		);
	}

	canAccess(roles?: UserRole[]): boolean {
		if (!roles?.length) return true;

		const effective = this.profileStore.effectiveRole();
		if (!effective) return false;

		const minRequired = Math.min(...roles.map(r => ROLE_LEVEL[r]));
		return ROLE_LEVEL[effective] >= minRequired;
	}
}
